export default __webpack_public_path__ + "static/media/help--setup-excel.6ed90683.png";